import { ISubmitNoteType } from 'transfix-ui/components/NotesCard'
import { IFileBody } from 'types/file'
import { ENDPOINTS } from 'utils/api/callApi'
import { keymirror } from 'utils/keymirror'

export const REQUEST_NOTES_ACTION_TYPES = keymirror({
  NOTES_REQUEST: null,
  NOTES_SUCCESS: null,
  NOTES_FAILURE: null,
})

export const SUBMIT_NOTE_ACTION_TYPES = keymirror({
  SUBMIT_NOTE_REQUEST: null,
  SUBMIT_NOTE_SUCCESS: null,
  SUBMIT_NOTE_FAILURE: null,
})

export const SUBMIT_NOTE_RESET = 'SUBMIT_NOTE_RESET'

export const ADD_ATTACHMENT_ACTION_TYPES = keymirror({
  ADD_ATTACHMENT_REQUEST: null,
  ADD_ATTACHMENT_SUCCESS: null,
  ADD_ATTACHMENT_FAILURE: null,
})

interface ISubmitNotesArgs extends Partial<ISubmitNoteType> {}

export const submitNote = (args: ISubmitNotesArgs, noteType: string = '') => {
  const {
    body,
    callbackDate = null,
    callbackTime = null,
    createdById,
    getNotesParams = {},
    noteableId,
    noteableType,
  } = args || {}
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.notes,
        method: 'POST',
        body: {
          note: {
            body,
            createdById,
            noteableId,
            noteableType,
            ...(callbackDate && {
              callbackDate,
              callbackTime,
            }),
          },
        },
        params: {
          filters: { noteableId, noteableType, noteType },
        },
        getNotesParams,
      },
      actionTypes: Object.keys(SUBMIT_NOTE_ACTION_TYPES),
    },
  }
}

export const attachFileToNote = (noteId: string, file: IFileBody) => {
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.notes,
        method: 'POST',
        id: noteId,
        group: 'note_documents',
        body: {
          note_document: {
            ...file,
          },
        },
      },
      actionTypes: Object.keys(ADD_ATTACHMENT_ACTION_TYPES),
    },
  }
}

export const getNotes = (id: number, type: string = 'Shipment', noteType: string = '') => {
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.notes,
        params: {
          perPage: 1000,
          filters: {
            noteableType: type,
            noteableId: id,
            noteType,
          },
        },
      },
      actionTypes: Object.keys(REQUEST_NOTES_ACTION_TYPES),
    },
  }
}

interface ISubmitCallbackArgs extends Partial<ISubmitNoteType> {}

export const submitCallback = ({
  body,
  callbackDate,
  callbackTime,
  calledBackAt,
  createdById,
  id,
  needsCallback,
  noteableId,
  noteableType,
  ...parameters
}: ISubmitCallbackArgs) => {
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.notes,
        method: 'PUT',
        body: {
          note: {
            body,
            createdById,
            noteableId,
            noteableType,
            callbackDate,
            callbackTime,
            calledBackAt,
            id,
            needsCallback,
            ...parameters,
          },
        },
        group: id,
        params: {
          filters: { noteableId, noteableType },
        },
      },
      actionTypes: Object.keys(SUBMIT_NOTE_ACTION_TYPES),
    },
  }
}

export const resetNoteState = () => ({
  type: SUBMIT_NOTE_RESET,
})
